import { ActionRuleParams } from '../../types';
import { formatValidation, getIslandLetter } from '../island-validation-format';
import { Notification } from '../../../notifications/notification.class';
import { NotificationType } from '../../../notifications/enums';
import { libLang } from '../../../../lang'


export const countertopDepthLimit = (params: ActionRuleParams): void => {
	const { refMap } = params;
	const { islands } = refMap
	const { notifications } = refMap.kitchen.design
	const { isGranite } = refMap.kitchen.material.countertop
	const maxCountertopDepth = isGranite ? 48 : 40;

	notifications.purgeReferences(libLang.validations.island.size.countertopDepth);

	if (!islands) return

	islands.children.forEach((island) => {
		// eslint-disable-next-line prefer-destructuring
		const sidePanel = island.panels.children[1];
		const { corners } = sidePanel.getSidePoints({ includeCountertop: true });
		const length = corners[0].getDistance(corners[1]);

		if (length > maxCountertopDepth) {
			notifications.add({
				refId: sidePanel.id,
				validationCode: libLang.validations.island.size.countertopDepth,
				description: formatValidation({ letter: getIslandLetter(island), islandDescription: island.description, location: sidePanel.label, issue: `Countertop depth ${length}" exceeds the ${maxCountertopDepth}" limit` }),
				type: NotificationType.Warn
			})
		}
	})
}
